import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SecurityIcon from '@mui/icons-material/Security';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="80vh"
    >
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          textAlign: 'center', 
          maxWidth: 500,
          borderRadius: 2,
          border: '1px solid #e0e0e0'
        }}
      >
        <SecurityIcon color="error" sx={{ fontSize: 70, mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          No tienes los permisos necesarios para acceder a esta página. 
          Por favor contacta al administrador si crees que deberías tener acceso.
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
          onClick={() => navigate('/chats')}
        >
          Volver a Mensajes
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDenied; 